import { render, staticRenderFns } from "./PerfilDados.vue?vue&type=template&id=a95492ac&scoped=true"
import script from "./PerfilDados.vue?vue&type=script&lang=js"
export * from "./PerfilDados.vue?vue&type=script&lang=js"
import style0 from "./PerfilDados.vue?vue&type=style&index=0&id=a95492ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95492ac",
  null
  
)

export default component.exports